export const APPROVAL_STATUSES = {
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
};

export const APPROVAL_STATUS_INFO = {
    [APPROVAL_STATUSES.PENDING]: { color: 'grey', label: 'Pending' },
    [APPROVAL_STATUSES.APPROVED]: { color: 'green', label: 'Approved' },
    [APPROVAL_STATUSES.REJECTED]: { color: 'red', label: 'Rejected' },
};

export const getApprovalStatusInfo = (status) =>
    APPROVAL_STATUS_INFO[status] ?? { color: 'grey', label: status };
